import React from 'react';
import { SelectedItem } from 'components';

const TypeOfItem = ({ item, exclude, deleteIncAction, deleteExcAction }) => {
  if (!item) return null;
  if (Object.prototype.hasOwnProperty.call(item, 'models'))
    return (
      <SelectedItem.ParentItem
        title='Brand'
        childrenName={item.brand}
        deleteIncAction={() => deleteIncAction(item.brand)}
      />
    );
  if (Object.prototype.hasOwnProperty.call(item, 'model')) {
    return (
      <SelectedItem.ChildrenItem
        title='Model'
        childrenName={item.model}
        exclude={exclude}
        deleteExcAction={() => deleteExcAction(item.counter)}
        deleteIncAction={() => deleteIncAction(item.counter)}
      />
    );
  }
};

export default TypeOfItem;
